import { render, staticRenderFns } from "./bindRelation.vue?vue&type=template&id=e0abe20c&scoped=true"
import script from "./bindRelation.vue?vue&type=script&lang=js"
export * from "./bindRelation.vue?vue&type=script&lang=js"
import style0 from "./bindRelation.vue?vue&type=style&index=0&id=e0abe20c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0abe20c",
  null
  
)

export default component.exports